const ACCESS_KEY = 'tm_access_token'
const REFRESH_KEY = 'tm_refresh_token'
const EXPIRES_AT_KEY = 'tm_token_expires_at'

export const normalizeBearerToken = (token: string) => token.replace(/^Bearer\s+/i, '')

export const authStorage = {
  getAccess: () => localStorage.getItem(ACCESS_KEY),
  getRefresh: () => localStorage.getItem(REFRESH_KEY),
  // Absolute expiry (epoch ms) of the access token, or null when unknown.
  getExpiresAt: (): number | null => {
    const raw = localStorage.getItem(EXPIRES_AT_KEY)
    if (!raw) return null
    const value = Number(raw)
    return Number.isFinite(value) ? value : null
  },
  // `expiresInSec` is the access-token lifetime in seconds (server `expireTime`).
  // When provided we persist the derived absolute expiry; when omitted the
  // existing expiry is left untouched so callers that only rotate tokens don't
  // accidentally wipe it.
  set: (access: string, refresh: string, expiresInSec?: number) => {
    localStorage.setItem(ACCESS_KEY, normalizeBearerToken(access))
    localStorage.setItem(REFRESH_KEY, normalizeBearerToken(refresh))
    if (expiresInSec && expiresInSec > 0) {
      localStorage.setItem(EXPIRES_AT_KEY, String(Date.now() + expiresInSec * 1000))
    }
  },
  clear: () => {
    localStorage.removeItem(ACCESS_KEY)
    localStorage.removeItem(REFRESH_KEY)
    localStorage.removeItem(EXPIRES_AT_KEY)
  },
}
